export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5323.3bc390a2.jpg";